
import { Themed } from '@theme-ui/mdx';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'theme-ui';

import ArrowChevron from '@src/assets/icons/chevron-down.svg';
import PageSlugs from '@src/components/layout/pageSlugs';

const SubjectCard = ({ name, image, slug, count }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;
  const subjectImage = getImage(image);

  return (
    <Link
      to={`/${slug}/${PageSlugs.subjectsSearch[locale]}`}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textDecoration: 'none',
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '24px 28px',
        width: '280px',
        transition: '200ms ease-in-out',
        boxShadow: '0px 10px 40px #0000001A',
        '&:hover': {
          transform: 'scale(1.1)',
        },
        '&:hover .card-image': {
          transform: 'scale(1.1)',
        },
        '&:hover .card-header': {
          transform: 'scale(0.95)',
        },
        '&:hover .card-footer': {
          transform: 'scale(0.95)',
        },
      }}
    >
      <Themed.h4
        className="card-header"
        sx={{
          margin: '0 0 27px 0',
          lineHeight: '1.2',
          color: 'black',
          transition: '200ms ease-in-out',
        }}
      >
        {name}
      </Themed.h4>
      <Box
        className="card-image"
        sx={{
          borderRadius: '50%',
          overflow: 'hidden',
          transform: 'translateZ(0)',
          width: '176px',
          height: '176px',
          margin: 'auto',
          transition: '200ms ease-in-out',
        }}
      >
        {subjectImage && (
          <GatsbyImage
            sx={{ height: '100%' }}
            image={subjectImage}
            alt=""
            width="176"
            height="176"
          />
        )}
      </Box>
      <Flex
        className="card-footer"
        sx={{
          transition: '200ms ease-in-out',
        }}
        pt={3}
      >
        <p sx={{ margin: '0', color: '#6D7292', fontSize: 3 }}>
          {count && (
            <>
              <span sx={{ color: 'text' }}>{count}</span>{' '}
              <span sx={{ textTransform: 'lowercase' }}>
                {i18n.t('teachers', { count: parseInt(count) })}
              </span>{' '}
            </>
          )}
        </p>
        <Flex sx={{ marginLeft: 'auto', alignItems: 'center' }}>
          <ArrowChevron sx={{ transform: 'rotate(-90deg)' }} />
        </Flex>
      </Flex>
    </Link>
  );
};

export default SubjectCard;
